<template>
  <el-dialog
    :title="$t('deleteSysDocument.title')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('deleteSysDocument.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('deleteSysDocument.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('deleteSysDocument.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteSysDocument } from '@/api/dev/sysDocument/sysDocumentApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteSysDocument',
  data() {
    return {
      dialogVisible: false,
      currentDocument: null
    }
  },
  methods: {
    open(data) {
      this.currentDocument = {
        ...data,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.currentDocument = null
      this.$emit('close')
    },
    async confirmDelete() {
      try {
        await deleteSysDocument(this.currentDocument)
        this.$message.success(this.$t('deleteSysDocument.deleteSuccess'))
        this.handleClose()
      } catch (error) {
        console.error('删除文档失败:', error)
        this.$message.error(this.$t('deleteSysDocument.deleteFailed'))
      }
    }
  }
}
</script>